import PropTypes from "prop-types"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import LessonContent from "~/components/Lessons/LessonContent"
import LessonSettings from "~/components/Lessons/LessonSettings"
import Page from "~/pages/Page"
import Router from "~/router"

const Content = ({ routes = [], ...rest }) => {
  return (
    <Page>
      <CourseLessonContentContainer
        leftComponent={<LessonSettings />}
        rightComponent={<LessonContent />}
      />
      <Router routes={routes} {...rest} />
    </Page>
  )
}

Content.propTypes = {
  routes: PropTypes.array,
}

export default Content
